import * as React from "react"
import { Link } from "gatsby"
//import { Helmet } from 'react-helmet'
import Header from './header'
import Footer from './footer'
import { Linkedin } from '../assets/linkedin'

const Layout = ({ location, title, children, page }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  const links = [
    <Link to="/about">About</Link>,
    <Link to="/tags">Tags</Link>
  ]

  const social = {
    //"linkedin": {
      //"link": "http://google.com",
      //"icon": <Linkedin />
    //}
  }

  const classList = ["root"]
  if (page !== undefined) {
    classList.push(`page-${page}`)
  }

  return (
    <div className={classList.join(" ")} data-is-root={isRootPath}>
      <Header
        brand="Kirill K"
        links={links}
        social={social}
        modeSwitcher={true}
      />
      <section className="main">
        <main className="content">
          <div style={{width:"100%"}}>
            {children}
          </div>
        </main>
      </section>
      <Footer />
    </div>
  )
}

export default Layout
